import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGameInfo } from "../interfaces/game-info";
import { IDraftedGamesState } from "../interfaces/slices";

const initialState: IDraftedGamesState = {
    info: {}
}

export const draftGamesSlice = createSlice({
    name: 'draftedGames',
    initialState,
    reducers: {
        addDraftedGames: (state, action: PayloadAction<Array<IGameInfo>>) => {
            state.info = {};
            action.payload.forEach((info: IGameInfo) => {
                state.info[info.gameName] = info;
            })
        },
    },
})

export const { addDraftedGames } = draftGamesSlice.actions
export default draftGamesSlice.reducer;